/*
  Base file for stub.
  This is where all the actual stub code will go.
*/

// REQUIRED IMPORTS
const $ = require('jquery');
import run from '../../../utilities/run';
import render from "../../../utilities/render";

export default function CsvErrors(targetSelector, data){
  const self = this;
  const errorData = data;
  const entryEl = $("<div class='entry-point'></div>");
  const mainHtml = render(
    require("./html/csvErrors.html"),
  );
  const mainEl = $(mainHtml);
  entryEl.append(mainEl);
  // END: REQUIRED TO LOAD STUB

  const elTable = mainEl.find(".csv-error-list");
  let csvErrorDataTable;

  self.init = function() {
    initTable();
  }

  function initTable(){
    csvErrorDataTable = elTable.dataTable({
      data: getTableData(),
      searching: false,
      paging: false,
      info: false,
      ordering: false,
      columnDefs: [
        { "targets": [0], "width": "10%" },
        { "targets": [1], "width": "20%" },
        { "targets": [2], "width": "25%" },
        { "targets": [3], "width": "45%" }
      ],
      columns: [
        {
          data: "line"
        },
        {
          data: "column",
        },
        {
          data: "valueEntered",
        },
        {
          data: "errorDetails"
        }
      ]
    });
  }

  function getTableData(){
    return errorData;
  }

  self.getErrorHtml = function() {
    return entryEl;
  }
};



// WEBPACK FOOTER //
// ./src/pages/asns/PackingTab/CsvErrors.js